import { validationIsEqual } from '../status';
import {
    validateEmail,
    validateName,
    validateContactNumber,
    validateAlphaNumericString,
    validateNumericString,
} from '@om/validation';
import {
    RELATIONSHIP_SET_VALUE,
    FIRST_NAME_SET_VALUE,
    EMAIL_SET_VALUE,
    POSTAL_ADDRESS_SET_VALUE,
    PHONE_NUMBER_SET_VALUE,
    setRelationshipValid,
    setPostalAddressValid,
    setFirstNameValid,
    setEmailValid,
    setPhoneNumberValid,
    TOWN_SET_VALUE,
    setTownValid,
} from '../../../actions/travelSs/nextOfKin';

let prevValidationAction = null;
export const nextOfKinValidation = (store, next, action) => {
    const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;
    const validationAction = (() => {
        let error;

        const validateString = (value, min, subject) => {
            const validators = [validateName, validateAlphaNumericString, validateNumericString];

            let customError = null;

            for (const validate of validators) {
                customError = validate(value, { min, subject });
                if (!customError) break;
            }

            return customError;
        };

        switch (action.type) {
            case RELATIONSHIP_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'Relationship',
                    min: 2,
                });
                return setRelationshipValid(error);

            case FIRST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'Full Name',
                });
                return setFirstNameValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Phone Number',
                    countryCode: gatsbyStack,
                });
                return setPhoneNumberValid(error);

            case POSTAL_ADDRESS_SET_VALUE:
                error = validateString(action.value, {
                    subject: 'Postal/Home Address',
                    min: 3,
                });
                return setPostalAddressValid(error);

                case TOWN_SET_VALUE:
                    error = validateName(action.value, {
                        subject: 'Town',
                    });
                    return setTownValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
